import { TGrouppedReportColummConfig, TReportSubTotalConfig } from '@monorepo/models';
import {
  TRequest_SaveReportConfiguration,
  TResponse_ReportMetricColumnConfig,
  TRequest_ReportMetricColumnConfig,
  TResponse_SaveReportConfigurationSuccess,
  TResponse_SaveReportConfigurationFailure,
  TResponse_ValidateReportMetricConfigSuccess,
  TResponse_ValidateReportMetricConfigFailure,
} from '@monorepo/types';
import { Action } from '@ngrx/store';
import { TValidateReportMetricConfig } from './advance-setting.facade';

export enum ReportAdavanceSettingActionTypes {
  LoadReportAdavceSettingConfig = '[REPORTS ADAVANCE_SETTING] LoadAdavanceSetting',
  LoadReportAdavceSettingConfigSuccess = '[REPORTS ADAVANCE_SETTING] LoadAdavanceSetting success',
  LoadReportAdavceSettingConfigFailure = '[REPORTS ADAVANCE_SETTING] LoadAdavanceSetting Failure',

  SaveReportMetricConfiguration = '[REPORTS ADAVANCE_SETTING] save Report Advance Configuration',
  SaveReportMetricConfigurationSuccess = '[REPORTS ADAVANCE_SETTING] Save Report Advance Configuration success',
  SaveReportMetricConfigurationFailure = '[REPORTS ADAVANCE_SETTING] Save Report Advance Configuration Failure',

  SaveMetricExpressionDisplayNameChange = '[REPORTS ADAVANCE_SETTING] Save Metric Expression Display Name Change',
  SaveSubTotalDisplayNameChange = '[REPORTS ADAVANCE_SETTING] Save Display Name Expression Display Name Change',

  ValidateReportMetricConfig = '[REPORTS ADAVANCE_SETTING] Validate Report Metric Config',
  ValidateReportMetricConfigSuccess = '[REPORTS ADAVANCE_SETTING] Validate Report Metric Config success',
  ValidateReportMetricConfigFailure = '[REPORTS ADAVANCE_SETTING] Validate Report Metric Config Failure',

  AdvanceReportMetricColumnUpdate = '[REPORTS ADAVANCE_SETTING] Update Report Metric Header ',
  MetricColumnReOrder = '[REPORTS ADAVANCE_SETTING] Metric Column ReOrder',
}

export class LoadReportAdavceSettingConfig implements Action {
  readonly type = ReportAdavanceSettingActionTypes.LoadReportAdavceSettingConfig;
  constructor(public request: TRequest_ReportMetricColumnConfig) {}
}

export class LoadReportAdavceSettingConfigSuccess implements Action {
  readonly type = ReportAdavanceSettingActionTypes.LoadReportAdavceSettingConfigSuccess;
  constructor(public metricColumnConfig: TResponse_ReportMetricColumnConfig) {}
}

export class LoadReportAdavceSettingConfigFailure implements Action {
  readonly type = ReportAdavanceSettingActionTypes.LoadReportAdavceSettingConfigFailure;
  constructor() {}
}

export class SaveReportMetricConfiguration implements Action {
  readonly type = ReportAdavanceSettingActionTypes.SaveReportMetricConfiguration;
  constructor(public reportConfigSaveRequest: TRequest_SaveReportConfiguration) {}
}

export class SaveReportMetricConfigurationSuccess implements Action {
  readonly type = ReportAdavanceSettingActionTypes.SaveReportMetricConfigurationSuccess;
  constructor(public response: TResponse_SaveReportConfigurationSuccess) {}
}

export class SaveReportMetricConfigurationFailure implements Action {
  readonly type = ReportAdavanceSettingActionTypes.SaveReportMetricConfigurationFailure;
  constructor(public status: TResponse_SaveReportConfigurationFailure) {}
}

export class SaveMetricExpressionDisplayNameChange implements Action {
  readonly type = ReportAdavanceSettingActionTypes.SaveMetricExpressionDisplayNameChange;
  constructor(public metricExpressions: TGrouppedReportColummConfig['metric']['columns']) {}
}

export class SaveSubTotalDisplayNameChange implements Action {
  readonly type = ReportAdavanceSettingActionTypes.SaveSubTotalDisplayNameChange;
  constructor(public subTotalColumns: TReportSubTotalConfig['columns']) {}
}

export class ValidateReportMetricConfig implements Action {
  readonly type = ReportAdavanceSettingActionTypes.ValidateReportMetricConfig;
  constructor(public validateReportMetricConfig: TValidateReportMetricConfig) {}
}

export class ValidateReportMetricConfigSuccess implements Action {
  readonly type = ReportAdavanceSettingActionTypes.ValidateReportMetricConfigSuccess;
  constructor(public res: TResponse_ValidateReportMetricConfigSuccess) {}
}

export class ValidateReportMetricConfigFailure implements Action {
  readonly type = ReportAdavanceSettingActionTypes.ValidateReportMetricConfigFailure;
  constructor(public res: TResponse_ValidateReportMetricConfigFailure) {}
}

export class AdvanceReportMetricColumnUpdate implements Action {
  readonly type = ReportAdavanceSettingActionTypes.AdvanceReportMetricColumnUpdate;
  constructor(public payload: TResponse_ReportMetricColumnConfig['headerColumns'][number]) {}
}

export class MetricColumnReOrder implements Action {
  readonly type = ReportAdavanceSettingActionTypes.MetricColumnReOrder;
  constructor(public payload: TMetricColumnReorderInfo) {}
}

export type TMetricColumnReorderInfo = { index: number; direction: -1 | 1 };

export type TReportAdavanceAction =
  | LoadReportAdavceSettingConfig
  | LoadReportAdavceSettingConfigSuccess
  | LoadReportAdavceSettingConfigFailure
  | SaveReportMetricConfiguration
  | SaveReportMetricConfigurationSuccess
  | SaveReportMetricConfigurationFailure
  | SaveMetricExpressionDisplayNameChange
  | SaveSubTotalDisplayNameChange
  | ValidateReportMetricConfig
  | ValidateReportMetricConfigSuccess
  | ValidateReportMetricConfigFailure
  | AdvanceReportMetricColumnUpdate
  | MetricColumnReOrder;
